import React from 'react';

import * as helpers from './helpers';

const HeartsIcon = ({
  color,
  width = 407.585,
  height = 407.585,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg
    {...helpers.getSvgDimensionsProps({ width, height })}
    {...helpers.getViewBoxProperty({ width, height })}
    {...props}>
    <g>
      <g>
        <path d="M384.033,71.263c-15.445-16.106-37.263-24.493-59.52-22.88c-28.4,2.88-50.48,23.36-60.88,34.96
			c-10.4-11.6-32.48-32-60.96-34.96c-22.257-1.613-44.075,6.774-59.52,22.88c-12.844,11.503-20.992,27.341-22.88,44.48
			c-12.846-9.093-28.106-14.161-43.84-14.56c-19.985,0.652-38.939,9.025-52.88,23.36c-18.37,16.956-26.816,42.114-22.4,66.72
			c8.72,61.52,80,137.52,139.28,167.28c2.264,1.141,4.936,1.141,7.2,0c32.614-17.679,61.774-41.094,86.08-69.12
			c8.407,5.913,17.2,11.258,26.32,16c2.264,1.141,4.936,1.141,7.2,0c58.88-29.68,130.56-105.92,139.2-167.44
			C410.849,113.377,402.402,88.219,384.033,71.263z M144.033,342.463c-54.64-29.2-119.2-98-127.04-153.44
			c-3.695-19.407,2.901-39.345,17.44-52.72c11.039-11.488,26.082-18.279,42-18.96c34.32,0,60.8,36.16,61.04,36.56
			c1.493,2.098,3.905,3.348,6.48,3.36c2.575-0.012,4.987-1.262,6.48-3.36c0,0,26.64-36.56,61.36-36.56
			c15.918,0.681,30.961,7.472,42,18.96c14.568,13.358,21.195,33.299,17.52,52.72C263.233,244.463,198.673,313.263,144.033,342.463z
			 M390.592,135.743c-8,55.36-72,124.24-127.04,153.36c-6.79-3.656-13.385-7.661-19.76-12c22.32-27.92,38.88-58.32,42.8-85.84
			c4.416-24.606-4.03-49.764-22.4-66.72c-13.848-14.163-32.606-22.468-52.4-23.2c-31.6,0-56,22.8-67.52,35.28
			c-2.16-2.48-4.88-5.28-8-8c-1.23-17.09,5.431-33.802,18.08-45.36c12.132-12.852,29.314-19.701,46.96-18.72c32,3.2,56,36,56,36.32
			c1.493,2.098,3.905,3.348,6.48,3.36c2.575-0.012,4.987-1.262,6.48-3.36c0,0,24-33.04,56-36.24
			c17.676-1.016,34.896,5.837,47.04,18.72C387.686,96.685,394.21,116.468,390.592,135.743z"/>
      </g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg>
);

export default HeartsIcon;
